// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"4e55fc6a","74":"5a4d0a9e","205":"c9f313b1","319":"9abe8bac","339":"89eaada1","455":"0e578b36","484":"14cb0921","517":"6c6cd5f0","551":"8912905c","629":"1aef4cae","640":"7ffd70eb","672":"477a6254","842":"01821987","869":"307896e8","974":"5be244d3"}[chunkId] + ".chunk.js";
};